import React from "react";
import "./NotFound.scss";
import Image from "../../images/NotFound.svg";

const NotFound = () => {
  return (
    <div className="notfound-container">
      <img src={Image} alt="NOT FOUND" />
    </div>
  );
};

export default NotFound;
